import { render, staticRenderFns } from "./cookie-notice.vue?vue&type=template&id=6df559be&scoped=true"
import script from "./cookie-notice.vue?vue&type=script&lang=js"
export * from "./cookie-notice.vue?vue&type=script&lang=js"
import style0 from "./cookie-notice.vue?vue&type=style&index=0&id=6df559be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df559be",
  null
  
)

export default component.exports